<template>
  <div class="mx-2 pt-2 py-2" style="background-color: #f9f9f9; height: 90vh">
    <loading
      v-model:active="pageLoader"
      :can-cancel="false"
      loader="dots"
      color="#02C782"
      background-color="#818585"
      width="130"
      height="130"
      :is-full-page="true"
    />
    <h1 class="flex justify-center text-2xl 100vh mb-5 pt-10">
      Quarterly Report
    </h1>
    <form class="max-w-md mx-auto">
      <diV class="flex flex-wrap filter mb-2">
        <!-- <div class="flex align-items-end"> -->
        <div class="mb-3 w-full">
          <label
            for="text"
            class="block mb-2 text-sm font-medium text-black dark:text-white"
          >
            Cities</label
          >
          <select
            style="width: 445px"
            multiple
            @change="countryChanged"
            ref="cities"
            v-model="selectDistrictid"
            id="cities"
            class="font-family-card text-[16px] rounded bg-white border mb-3 border-gray-300 text-black text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <!-- <option  value="all"> Cities</option> -->
            <option
              v-for="district in selectDistrict"
              :key="district.id"
              :value="district.id"
            >
              {{ district.name }}
            </option>
          </select>
        </div>
        <div class="mb-3 w-full">
          <label
            for="text"
            class="block mb-2 text-sm font-medium text-black dark:text-white"
          >
            Hospitals</label
          >
          <select
            multiple
            v-model="counteryid"
            ref="hospitals"
            id="hospitals"
            class="js-example-disabled-results bg-gray-50 rounded border mr-3 border-gray-300 text-black text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value=""></option>
            <option
              v-for="hospital in countries"
              :key="hospital.id"
              :value="hospital.id"
            >
              {{ hospital.name }}
            </option>
          </select>
        </div>
      </diV>

      <div class="mb-5">
        <label
          for="countries"
          class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >Select Year</label
        >
        <select
          id="countries"
          v-model="year"
          required
          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option selected value="0">Choose a Year</option>
          <option value="2020">2020</option>
          <option value="2021">2021</option>
          <option value="2022">2022</option>
          <option value="2023">2023</option>
          <option value="2024">2024</option>
          <option value="2025">2025</option>
          <option value="2026">2026</option>
          <option value="2027">2027</option>
          <option value="2028">2028</option>
          <option value="2029">2029</option>
          <option value="2030">2030</option>
        </select>
      </div>
      <div class="mb-5">
        <label
          for="countries"
          class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >Select Quater</label
        >
        <select
          id="countries"
          v-model="quater"
          required
          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option selected value="0">Choose a Quater</option>
          <option value="1">First Quater</option>
          <option value="4">Second Quater</option>
          <option value="7">Third Quater</option>
          <option value="10">Fourth Quater</option>
        </select>
      </div>
      <div class="flex-wrap mb-4 items-baseline">
        <div class="flex mb-5 justify-between">
          <div class="flex items-center dark:border-gray-700">
            <router-link
              to="/"
              class="text-white rounded-lg bg-button-blue hover:bg-bg-hover-save focus:ring-4 focus:ring-blue-300 font-medium text-sm px-5 py-2 md:py-2.5 dark:bg-regal-blue focus:outline-none dark:focus:ring-blue-800"
            >
              Back
            </router-link>
          </div>
          <button
            :disabled="isLoadingpdf"
            @click="handleexportpdf"
            class="text-white bg-bg-save hover:bg-hover-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center relative"
          >
            {{ isLoadingpdf ? "Exporting " : "Export PDF" }}
            &nbsp;
            <svg
              v-if="isLoadingpdf"
              aria-hidden="true"
              role="status"
              class="inline w-4 h-4 me-3 text-white animate-spin"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor"
              />
            </svg>
          </button>
          <button
            :disabled="isLoadingExcel"
            @click="handleexportexcel"
            class="text-white bg-bg-save hover:bg-hover-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center relative"
          >
            {{ isLoadingExcel ? "Exporting " : "Export Excel" }}
            &nbsp;
            <svg
              v-if="isLoadingExcel"
              aria-hidden="true"
              role="status"
              class="inline w-4 h-4 me-3 text-white animate-spin"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUnmounted } from "vue";
import { useScanCodeStore } from "@/store/QRScanCode";
import Swal from "sweetalert2";
import axiosInstance from "@/plugins/axios";
import $ from "jquery";
import "select2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
const qrscancode = useScanCodeStore();
const isLoadingExcel = ref(false);
const endDate = ref();
const countries = ref([]);
const selectDistrict = ref([]);
const selectDistrictid = ref([]);
const isLoading = ref(false);
const isLoadingpdf = ref(false);
const quater = ref(0);
const year = ref(0);

const handleexportpdf = async () => {
  if (year.value === 0 || quater.value === 0) {
    // Show an error message or handle the missing dates as needed
    Swal.fire({
      icon: "warning",
      title: "warning",
      text: "Please select   year and quarter.",
    });
    event.preventDefault();

    return;
  }
  isLoadingpdf.value = true;
  try {
    const requestBody = {
      district_ids: selectDistrictid.value,
      hospital_ids: $("#hospitals").val(),
      year: year.value,
      quarter: quater.value,
    };
    const confirmation = await Swal.fire({
      title: "Export Data",
      text: "Heads up! Exporting may take some time. ",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ok!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    if (confirmation.isConfirmed) {
      const response = await axiosInstance.post(
        "/pdf-report/quarterly",
        requestBody
      );
      if (response.status === 200) {
        window.open(response.data.data.link, "_blank");
        // loadingAlert.close()
      } else {
        throw new Error("Unexpected status code: " + response.status);
      }
    }
  } catch (error) {
    Swal.close();
    Swal.fire({
      icon: "warning",
      title: "Something went wrong!",
      text: error?.response?.data?.message,
    });
    isLoading.value = false;

    throw error;
  } finally {
    isLoadingpdf.value = false;
  }
};
const handleexportexcel = async () => {
  if (year.value === 0 || quater.value === 0) {
    // Show an error message or handle the missing dates as needed
    Swal.fire({
      icon: "warning",
      title: "warning",
      text: "Please select  year and quarter.",
    });
    event.preventDefault();

    return;
  }
  isLoadingExcel.value = true;
  try {
    const requestBody = {
      district_ids: selectDistrictid.value,
      hospital_ids: $("#hospitals").val(),
      year: year.value,
      quarter: quater.value,
    };
    await qrscancode.getExcelExcelQuaterlyReport(requestBody); // Assuming this is an asynchronous function
  } catch (error) {
    console.error("Error exporting Excel:", error);
    // Handle errors as needed
  } finally {
    isLoadingExcel.value = false;
  }
};
// Function to fetch countries from API
const fetchCountries = async () => {
  try {
    const response = await axiosInstance.get("/assigned-collection-districts"); // Replace with your API endpoint
    const districts = response.data.data;
    countryChanged();
    // Extracting all district names
    const districtNames = districts.map((district) => district);
    selectDistrict.value = districtNames;
  } catch (error) {
    console.error("Error fetching countries:", error);
    // Handle error or show error message
  }
};
const countryChanged = async () => {
  try {
    selectDistrictid.value = $("#cities").val();
    const response = await axiosInstance.post(`/multiple-districts/hospitals`, {
      district_ids: $("#cities").val(),
    });
    const countery = response.data.data;
    const counterys = countery.map((countery) => countery);
    countries.value = counterys;
  } catch (error) {
    console.error("Error fetching district info:", error);
    // Handle error or show error message
  }
};
const cities = ref(null);

onMounted(() => {
  $(cities.value).select2();

  $(cities.value).on("change", () => {
    countryChanged();
  });
});
$(document).ready(function () {
  // Initialize Select2 for Select 1
  $("#hospitals").select2({
    placeholder: "All Hospitals",
    allowClear: true,
  });
  $("#cities").select2({
    placeholder: "All Cities",
    allowClear: true,
  });
});
onMounted(async () => {
  await fetchCountries();
  //   applyFilters()
});
</script>